import { render, staticRenderFns } from "./SpendLimitReportTable.vue?vue&type=template&id=53f21a10"
import script from "./SpendLimitReportTable.vue?vue&type=script&lang=js"
export * from "./SpendLimitReportTable.vue?vue&type=script&lang=js"
import style0 from "./SpendLimitReportTable.vue?vue&type=style&index=0&id=53f21a10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports